export default __webpack_public_path__ + "images/0x62227c75908b7d358a9d70ea4670f57f8b012ccc.png";